module.exports = __webpack_public_path__ + "img/delete-event.fc2338b2.svg";